'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./ScrollableCard.scss');

var _AbstractReactComponent = require('../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komponenta panelu, který je na výšku 100% a má scrolovatelný pouze obsah, hlaviška scrolovatelná není.
 */
// --
var ScrollableCard = function (_AbstractReactCompone) {
    (0, _inherits3.default)(ScrollableCard, _AbstractReactCompone);

    function ScrollableCard() {
        (0, _classCallCheck3.default)(this, ScrollableCard);
        return (0, _possibleConstructorReturn3.default)(this, (ScrollableCard.__proto__ || (0, _getPrototypeOf2.default)(ScrollableCard)).apply(this, arguments));
    }

    (0, _createClass3.default)(ScrollableCard, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                detail = _props.detail,
                header = _props.header,
                children = _props.children,
                className = _props.className;


            var wrapperClassNames = (0, _classnames2.default)(className, "card-scrollable container-fluid", {
                "card": !detail,
                "card-detail": detail
            });

            return _react2.default.createElement(
                'div',
                { className: wrapperClassNames },
                header && _react2.default.createElement(
                    'div',
                    { className: 'card-scrollable-header' },
                    header
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card-scrollable-content' },
                    children
                )
            );
        }
        // TODO [R: dokumentace]

    }]);
    return ScrollableCard;
}(_AbstractReactComponent2.default);

ScrollableCard.propTypes = {
    // header:
    // className:
    // detail
};
exports.default = ScrollableCard;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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